import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../../firebase'


function Categories({recipeId}) {
    const [categories, setCategories] = useState([])

    useEffect(() => {

        try {
            const categoriesRef = firestore.collection("recipes").doc(recipeId).collection("categories")
            categoriesRef.onSnapshot(({docs}) => {
                const categories = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setCategories(categories)
            })
        } catch (error) {
            console.log(error)
        }

    }, [recipeId])

    return (
        <>
            {categories && categories.map((category, index) => {
                return (
                    <div key={index} className="col-6 col-md-6 col-lg-4">
                        <Link to={`/category/${category.category_id}`}>
                            <img 
                                style={{maxWidth: "20px"}} 
                                alt="Recipe category" 
                                src={category.imageUrl} 
                                className="img-fluid rounded-circle mr-2" 
                            />
                            {category.category}  
                        </Link>
                    </div>
                )
            })}
        </>
    )

}
export default Categories